var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02637 21.2301C7.02637 20.2453 7.41756 19.3009 8.11388 18.6046C8.8102 17.9083 9.75461 17.5171 10.7394 17.5171C11.7241 17.5171 12.6685 17.9083 13.3648 18.6046C14.0612 19.3009 14.4524 20.2453 14.4524 21.2301H7.02637Z",
    stroke: "#51546B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02637 21.2301C7.02637 20.2453 7.41756 19.3009 8.11388 18.6046C8.8102 17.9083 9.75461 17.5171 10.7394 17.5171C11.7241 17.5171 12.6685 17.9083 13.3648 18.6046C14.0612 19.3009 14.4524 20.2453 14.4524 21.2301H7.02637Z",
    stroke: "#51546B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5509 1L15.0949 9.77681C14.3865 12.954 12.8028 13.4056 10.6426 13.4056C8.48244 13.4056 6.90298 12.954 6.1904 9.77681L4.73438 1H16.5509Z",
    stroke: "#51546B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5509 1L15.0949 9.77681C14.3865 12.954 12.8028 13.4056 10.6426 13.4056C8.48244 13.4056 6.90298 12.954 6.1904 9.77681L4.73438 1H16.5509Z",
    stroke: "#51546B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6426 13.4058V17.5157",
    stroke: "#51546B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6426 13.4058V17.5157",
    stroke: "#51546B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5506 1H20.2846C20.2846 1 19.9634 5.50132 18.5943 6.87178C17.0514 8.41477 15.4326 7.73866 15.4326 7.73866",
    stroke: "#51546B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5506 1H20.2846C20.2846 1 19.9634 5.50132 18.5943 6.87178C17.0514 8.41477 15.4326 7.73866 15.4326 7.73866",
    stroke: "#51546B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73263 1H1C1 1 1.31982 5.50132 2.68326 6.87178C4.22625 8.41477 5.84499 7.73866 5.84499 7.73866",
    stroke: "#51546B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73263 1H1C1 1 1.31982 5.50132 2.68326 6.87178C4.22625 8.41477 5.84499 7.73866 5.84499 7.73866",
    stroke: "#51546B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/Trophy.24b59ed76644b249c62e164e522ed233.svg";
export { ForwardRef as ReactComponent };